import { Button, Fab, Grid, Paper } from "@mui/material";
import styles from "../../Styles/clientPanel.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Edit } from "@mui/icons-material";
import light from "../../Themes/light";
import GenericModal from "../GenericModal";
import { EClientContentModal, EWidths } from "../../Utils/Enums";
import { Fragment, useState } from "react";
import { FormsIds } from "../../Utils/Constants";
import genericStyles from "../../Styles/genericStyles.module.css";
import ClientForm from "./ClientForm";
import ClientCategoryManagement from "./ClientCategoryManagement";
import { ClientGeneralInfoProps } from "../../Utils/Types";
import { AddressModel, ClientModel } from "../../Utils/Models";

export default function ClientGeneralInfo(props: ClientGeneralInfoProps) {
  const { client, setClient, onSave } = props;
  const [currentContent, setCurrentContent] = useState<
    EClientContentModal.FORM | EClientContentModal.CLIENT_CATEGORY
  >(EClientContentModal.FORM);
  const [isAnimating, setIsAnimating] = useState(false);
  const [open, setOpen] = useState(false);
  /**
   *
   */
  const toggleOpen = () => {
    setOpen(!open);
    if (open) {
      setCurrentContent(EClientContentModal.FORM);
    }
  };
  /**
   *  Handle the content change
   */
  const handleContentChange = () => {
    setIsAnimating(true); // Start the animation
    setTimeout(() => {
      setCurrentContent(
        currentContent === EClientContentModal.FORM
          ? EClientContentModal.CLIENT_CATEGORY
          : EClientContentModal.FORM // Toggle content
      );
      setIsAnimating(false); // End the animation
    }, 500); // Match the animation duration
  };

  /**
   *
   */
  const handleBackAction = () => {
    handleContentChange();
  };

  /**
   *
   * @returns
   */
  const renderGenericModalActions = () => {
    switch (currentContent) {
      case EClientContentModal.FORM:
        return (
          <Fragment>
            <Button
              color="secondary"
              variant="outlined"
              fullWidth
              onClick={toggleOpen}
            >
              {Vocabulary.cancel}
            </Button>
            <Button
              fullWidth
              type="submit"
              form={FormsIds.clients}
              variant="contained"
            >
              {Vocabulary.save}
            </Button>
          </Fragment>
        );
      case EClientContentModal.CLIENT_CATEGORY:
        return (
          <Button
            color="secondary"
            variant="outlined"
            fullWidth
            onClick={handleBackAction}
          >
            {Vocabulary.back}
          </Button>
        );
      default:
        break;
    }
  };

  /**
   *
   * @returns
   */
  const renderClientInfo = () => {
    return (
      <Grid container>
        <Grid item xs={3} sm={3} md={3}>
          <p>
            <label>{Vocabulary.firstName}:</label> {client?.firstName}
          </p>
          <p>
            <label>{Vocabulary.lastName}:</label> {client?.lastName}
          </p>
          <p>
            <label>{Vocabulary.email}:</label> {client?.email}
          </p>
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          <p>
            <label>{Vocabulary.address}:</label>{" "}
            {AddressModel.stringify(client?.address)}
          </p>
          <p>
            <label>{Vocabulary.phoneNumbers}:</label>{" "}
            <span key={client?.phone}>{client?.phone}</span>
          </p>
        </Grid>
        <Grid item xs={1} sm={1} md={1}>
          <Fab
            onClick={toggleOpen}
            style={{
              backgroundColor: light.palette.header?.main,
              color: light.palette.textColorSecondary?.main,
            }}
            className={styles.editBtn}
            aria-label="edit"
            size="small"
          >
            <Edit />
          </Fab>
        </Grid>
      </Grid>
    );
  };

  return (
    <Paper className={styles.paper}>
      {renderClientInfo()}
      <GenericModal
        onClose={toggleOpen}
        maxWidth={EWidths.MD}
        open={open}
        actions={
          <div className={genericStyles.modalActions}>
            {renderGenericModalActions()}
          </div>
        }
        title={Vocabulary.editModalTitle}
      >
        <div className={styles.modalContainer}>
          <div
            className={`${styles.modalContentWrapper} ${
              isAnimating ? styles.animateOut : styles.animateIn
            }`}
          >
            {currentContent === EClientContentModal.FORM ? (
              <div className={styles.newContent}>
                <ClientForm
                  onClose={() => {
                    setOpen(false);
                  }}
                  onSuccess={(event: any, client: any) => {
                    setClient(client);
                    if (onSave) onSave();
                  }}
                  selectedClient={client || new ClientModel()}
                  handleContentChange={handleContentChange}
                />
              </div>
            ) : (
              <div className={styles.newContent}>
                <ClientCategoryManagement
                  handleContentChange={handleContentChange}
                />
              </div>
            )}
          </div>
        </div>
      </GenericModal>
    </Paper>
  );
}
